<template>
  <section class="section faq__section --dark w-95">
    <div class="faq__section-title" v-reveal>
      <h2 class="title --uppercase">{{ content.title }}</h2>
			<HighlightableText :text="content.description" />
    </div>
    <ul>
      <FaQuestion :content="question" v-for="question in content.items" :key="question.flexKey"/>
    </ul>
  </section>
</template>

<script>
import {HighlightableText} from '@/components/blocks'
import {FaQuestion} from '@/components/cards'
import {HasContentMixin} from '@/mixins'

export default {
  name: 'FaqSection',
  mixins: [HasContentMixin],
  components: {FaQuestion, HighlightableText}
}
</script>